import React from "react";
import { ArrowUp, ArrowDown, ChevronsUpDown } from "lucide-react";

export const SortHeader = ({ label, dir, onClick, className = "text-left", testid = "sort-owner-name" }) => (
  <th className={`py-3 px-4 ${className}`}>
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      className="inline-flex items-center gap-1 hover:text-foreground transition-colors select-none"
    >
      {label}
      {dir === "asc" ? <ArrowUp className="h-3.5 w-3.5 text-primary" />
        : dir === "desc" ? <ArrowDown className="h-3.5 w-3.5 text-primary" />
        : <ChevronsUpDown className="h-3.5 w-3.5 opacity-50" />}
    </button>
  </th>
);

// Keep mixed-load members (same group_id) together, at the group's first position.
const clusterGroups = (rows) => {
  const byGroup = {}; rows.forEach((r) => { if (r.group_id) (byGroup[r.group_id] = byGroup[r.group_id] || []).push(r); });
  const out = []; const done = {};
  rows.forEach((r) => {
    if (!r.group_id) { out.push(r); return; }
    if (done[r.group_id]) return;
    done[r.group_id] = true; out.push(...byGroup[r.group_id]);
  });
  return out;
};

export const useOwnerSort = (rows, key = "owner_name") => {
  const [dir, setDir] = React.useState(null);
  const toggle = () => setDir((d) => (d === "asc" ? "desc" : d === "desc" ? null : "asc"));
  const sorted = React.useMemo(() => {
    let s = rows;
    if (dir) {
      s = [...rows].sort((a, b) =>
        String(a[key] || "").localeCompare(String(b[key] || ""), undefined, { sensitivity: "base", numeric: true })
      );
      if (dir === "desc") s.reverse();
    }
    return clusterGroups(s);
  }, [rows, dir, key]);
  return { sorted, dir, toggle };
};
